import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding, ElementRef, ViewChild, AfterViewInit, Input, AfterContentInit, OnDestroy, Renderer2, ViewContainerRef, TemplateRef, Output, EventEmitter } from '@angular/core';
import { ButtonInfo, ButtonComponent } from '../button.component';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { EnvService } from 'src/app/env.service';
import { UUID } from 'angular2-uuid';
import { ButtonGroupService } from 'src/app/services/button-group.service';
import { clone } from 'lodash';


@Component({
  selector: 'app-button-proxy',
  templateUrl: './button-proxy.component.html',
  styleUrls: ['./button-proxy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonProxyComponent implements AfterContentInit, OnDestroy {

  // tslint:disable-next-line: no-input-rename
  @Input('button-class') buttonClass = '';
  private _group: string = '';
  @Input('group') group: string = '';
  @ViewChild('btn') button: ButtonComponent;
  public dropdown: HTMLElement;
  @ViewChild('contentRef') contentRef: TemplateRef<any>;
  // tslint:disable-next-line: no-input-rename
  @Input('is-drop-down') isDropDown: boolean;
  // tslint:disable-next-line: no-input-rename
  @Input('dropdown-width') dropDownWidth = 'calc(100vh - 0px)';
  @HostBinding('style.max-width') maxWidthStyle = 'auto';
  @Output() click = new EventEmitter<ButtonInfo>();

  private _dropdownTitle: string = '';
  @Input('dropdown-title')
  set dropdownTitle(title) {
    this._dropdownTitle = title;
    this.cdr.markForCheck();
    this.cdr.detectChanges();
    if(this.buttonInfo) {
      this.RefreshView(this.buttonInfo);
    }
  }
  get dropdownTitle():string {
    return this._dropdownTitle;
  }

  public dropDownLeft = '0px';
  private subscriptions = new SubScriptionMgr();
  public buttonInfo: ButtonInfo;
  public dataToggleString = 'dropdown'
  public destroyed = false;;
  private resizeHandler: AnyHandler;
  public dropDownVis = false;
  @Output() dropDownVisChange = new EventEmitter<boolean>();
  @HostBinding('attr.id') guiID: string;
  public dropdownGuiID = '';
  public dropdownTop = '0px';
  public dropdownLeft = '0px';
  public dropdownRight = '0px';
  public dropdownMaxHeight = '100vh';
  public setting = false;
  public caretTop: string = '0px';
  public caretCenter: string = '0px';
  public caretVis = false;

  public set(info: ButtonInfo) {
    // this.dropDownVis = false;
    this.setting = true;
    this.buttonInfo = undefined;
    this.cdr.detectChanges();
    this.buttonInfo = info;
    this.cdr.detectChanges();
    this.setting = false;
    this.button.dataTitle = !!info.title ? info.title : '';
    this.Resized();
  }
  public get guidId(): string {
    if (!this.buttonInfo) {
      return undefined;
    }
    return this.buttonInfo.guiId;
  }

  @Input('max-width')
  set maxWidth(size: string) {
    this.maxWidthStyle = size;
    this.cdr.detectChanges();
  }
  private changeDetector: MutationObserver;
  constructor(private viewContainerRef: ViewContainerRef,
    private env: EnvService, private renderer: Renderer2,
    private cdr: ChangeDetectorRef, private domNode: ElementRef,
    private groups: ButtonGroupService) {
    this.guiID = UUID.UUID();
    this.dropdownGuiID = UUID.UUID();
  }

  ngAfterContentInit(): void {
    this.resizeHandler = () => {
      this.Resized();
    }
    window.addEventListener('resize', this.resizeHandler);


    if (!this.dropdown) {
      window.requestAnimationFrame(() => {
        this.ngAfterContentInit();
      });
      return;
    }
    this.Resized();
    // this.renderer.removeChild(this.domNode.nativeElement,this.dropdown.nativeElement,false);
    //window.document.body.appendChild(this.dropdown.nativeElement);

  }
  RefreshView(button: ButtonInfo) {
    if (this.buttonInfo.guiId === button.guiId) {
      this.buttonInfo = button;
      if (!this.setting) {
        this.cdr.detectChanges();
      }
    }
  }
  Resized() {
    if (!this.dropdown) {
      const dropdown = document.getElementById(this.dropdownGuiID)
      if (!!dropdown) {
        this.dropdown = dropdown;
      } else {
        return;
      }
    }
    if (!this.button) {
      return;
    }
    const vis = this.dropDownVis;
    this.dropdownTop = '0px';
    this.dropdownLeft = '0px';
    this.cdr.detectChanges();

    const containerPosition = this.env.GetPosition(this.domNode.nativeElement);
    const containerRect = this.domNode.nativeElement.getBoundingClientRect();
    const topOffset = containerRect.y;

    this.dropdown.style.flexWrap = 'nowrap';
    const dropdownRect = this.dropdown.getBoundingClientRect();
    this.dropdown.style.setProperty('width', 'fit-content');
    this.cdr.detectChanges();

    const fullWidth = dropdownRect.width;
    let left = Math.max(0, containerPosition.left);// + (containerRect.width / 2.0) - (fullWidth / 2));
    left += containerRect.width / 2.0;
    left -= dropdownRect.width / 2.0;

    this.dropdownLeft = Math.max(0, left) + 'px';
    this.cdr.detectChanges();

    const maxWidth = Math.min(fullWidth, document.documentElement.clientWidth);
    left = Math.max(0, containerPosition.left);// + (containerRect.width / 2.0) - (fullWidth / 2));
    left += containerRect.width / 2.0;
    left -= maxWidth / 2.0;
    const right = left + fullWidth;
    const testWidth = right - left;

    if (right > document.documentElement.clientWidth) {
      left = document.documentElement.clientWidth - dropdownRect.width;
    }
    if (left < 0) {
      left = 0;
    }
    this.dropdownLeft = left + 'px';
    this.dropdownRight = 'auto';

    this.cdr.detectChanges();
    this.dropdownTop = `calc(${containerRect.bottom}px + .6rem)`;//'calc(var(--title-height) + var(--subtitle-height) + .5rem)';
    this.dropdown.style.setProperty('top', this.dropdownTop);
    this.cdr.detectChanges();

    this.dropdownMaxHeight = `calc(100vh - ${this.dropdownTop}`;// 'calc(' + window.innerHeight + 'px - ' + this.dropdownTop + ')';
    this.cdr.detectChanges();

    this.dropdown.classList.toggle('hidden', !vis);
    this.caretVis = vis;
    this.dropdown.style.flexWrap = 'wrap';
    this.cdr.detectChanges();


    /*const dropDownLeft = (rect.left) + 'px';
    if (this.destroyed === false) {
      this.dropDownLeft = '-' + dropDownLeft + ' !important';
      this.dropDownWidth = 'calc(100vw - ' + dropDownLeft + ')';


    }*/
    this.cdr.detectChanges();

  }
  ngOnDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = undefined;
    }
    this.destroyed = true;
  }
  ToggleDropDown(onOff?: boolean) {
    this.dropDownVis = !this.dropdown.classList.contains('hidden');
    if (this.dropDownVis === true) {
      this.caretVis = false;
      this.dropDownVis = false;
      this.dropDownVisChange.emit(this.dropDownVis);
      this.Resized();
      return;
    }
    /*const elements = document.getElementsByClassName('sl-dropdown-menu');
    for (let i = 0; i < elements.length; i++) {
      const element = elements.item(i);
      element.classList.toggle('hidden', true);
    }*/
    this.groups.CloseAll();
    this.dropdown.classList.toggle('hidden', false);
    this.dropDownVis = (onOff !== undefined) ? onOff : !this.dropdown.classList.contains('hidden');
    this.cdr.detectChanges();
    this.dropDownVisChange.emit(this.dropDownVis);
    this.Resized();

  }
  DropdownReady() {
    if (document.getElementsByClassName('work-view').length === 0) {
      window.requestAnimationFrame(() => {
        this.DropdownReady();
      })
      return;
    }

    const dropdownViewRef = this.viewContainerRef.createEmbeddedView(this.contentRef);
    dropdownViewRef.detectChanges();

    for (const node of dropdownViewRef.rootNodes) {
      const element: HTMLElement = document.getElementsByClassName('work-view').item(0).appendChild(node) as HTMLElement;



    }


  }
  HandleButtonChange(info: ButtonInfo) {
    const hasChange = this.buttonInfo.isOn !== info.isOn;
    this.buttonInfo.isOn = info.isOn;
    if (this.buttonInfo.toggleable === true) {
      if (hasChange) {
        this.groups.Toggle(this.buttonInfo);
        this.RefreshView(info);
      }
    }
  }
  HandleClick() {
    this.click.emit(this.buttonInfo);
  }
  Close() {
    this.dropDownVis = false;
    this.dropdown.classList.toggle('hidden', true);

    this.caretVis = false;
    this.cdr.detectChanges();
  }

}
